import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, ThemeProvider, Typography } from '@mui/material';


function ApplicationsUserView() {

  const { t } = useTranslation();

  const apps = [
    { title: t('ui.application.aszende_app'), image: '/resources/UI/Application/Views/ApplicationsUserView/aszento.jpg', url:'https://intranet.aszende.com/aszende-app' },    
    { title: t('ui.application.salesforce'), image: '/resources/UI/Application/Views/ApplicationsUserView/Salesforce.svg', url:'https://aszende.my.salesforce.com/' },
    { title: t('ui.application.corporate_webmail'), image: '/resources/UI/Application/Views/ApplicationsUserView/outlook.png', url:'https://outlook.office365.com/owa/aszende.com/' },
    { title: t('ui.application.learning_aszende'), image: '/resources/UI/Application/Views/ApplicationsUserView/moodle.jpeg', url:'http://learning.aszende.com/' },
    { title: t('ui.application.binsa'), image: '/resources/UI/Application/Views/ApplicationsUserView/binsa.png', url:'https://binsa.aszende.com:8443/' },
    { title: t('ui.application.crm'), image: '/resources/UI/Application/Views/ApplicationsUserView/crm.png', url:'https://binsa.aszende.com:8443/crm' },
    { title: t('ui.application.it_portal'), image: '/resources/UI/Application/Views/ApplicationsUserView/jira.png', url:'https://intranet-aszende.atlassian.net/servicedesk/customer/portal/2' },
    { title: t('ui.application.agile'), image: '/resources/UI/Application/Views/ApplicationsUserView/agile.svg', url:'https://aszende.crm4.dynamics.com/' },
    { title: t('ui.application.power_bi'), image: '/resources/UI/Application/Views/ApplicationsUserView/powerbi.png', url:'https://app.powerbi.com/' },
    { title: t('ui.application.anydesk'), image: '/resources/UI/Application/Views/ApplicationsUserView/anydesk.png', url:'https://anydesk.com/es/downloads/thank-you?dv=win_exe' },
    { title: t('ui.application.jori'), image: '/resources/UI/Application/Views/ApplicationsUserView/jori.png', url:'https://retribucion.joriarmengol.com/login.php' },
    { title: t('ui.application.web_fleet_solutions'), image: '/resources/UI/Application/Views/ApplicationsUserView/weebFleetLogo.jpeg', url:'https://www.webfleet.com/es_es/webfleet/products/login/?application=classic&target=https://auth.webfleet.com/uaa/login' },
    { title: t('ui.application.aszende_fleet'), image: '/resources/UI/Application/Views/ApplicationsUserView/flota.png', url:'http://flota.aszende.com/' },
    { title: t('ui.application.hydra'), image: '/resources/UI/Application/Views/ApplicationsUserView/dialoga.png', url:'https://hydra.dialoga.io/' },
 
  ];

  return (
    <ThemeProvider
        theme={{
            palette: {
                primary: {
                    main: '#007FFF',
                    dark: '#0066CC',
                },
            },
        }}
    >
        <Grid container spacing={2} justifyContent="center" sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
            {apps.map((app, index) => (
                <Grid item key={index} xs={12} sm={6} md={4} lg={3} xl={2}>
                    <Box
                        sx={{
                            width: '100%',
                            height: 230,
                            borderRadius: 3,
                            boxShadow: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',                   
                            bgcolor: 'white',
                            overflow: 'hidden',
                            border: '1px solid #e0e0e0',
                            cursor: 'pointer',
                            margin: '0 auto',
                            maxWidth: 200,
                            '&:hover': {
                                boxShadow: 6,
                            },
                        }}
                        onClick={() => window.open(app.url, '_blank')}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <img src={app.image} alt={app.title} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                        </Box>
                        <Typography variant="body2" align="center" color="primary.main" sx={{ p: 1 }}>
                            {app.title}
                        </Typography>
                    </Box>
                </Grid>
            ))}
        </Grid>
    </ThemeProvider>
  );
}
export default ApplicationsUserView;